<template>
  <div>
    <div class="according_block">
      <div class="according_box" v-for="faq in faqs" :key="faq.id">
        <div class="according_title font-active" @click="openMenu(faq.id)" >
          {{ faq.question }}
          <div :class="[ expand === faq.id ? 'down_arrow' : 'up_arrow' ]"></div>
        </div>
        <div class="according_body" v-show="expand === faq.id">
          <p>{{ faq.answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const faqs = [
  { id: 1, question: 'What are lab diamonds made of?', answer: 'Lab created diamonds are made of carbon. They have the same physical and chemical composition as mined diamonds and also look the same.' },
  { id: 2, question: 'How are HPHT lab grown diamonds made?', answer: 'In the HPHT process, a tiny diamond piece acting as a seed is placed inside a containment filled with carbon. The seed is exposed to high pressure and temperature, letting pure carbon melt to form a diamond around the seed. Upon cooling, a pure carbon diamond is formed.' },
  { id: 3, question: 'How are CVD lab grown diamonds made?', answer: 'In the CVD process, a diamond seed is placed in a sealed enclosure and heated at a high temperature. Carbon-rich gas is then filled inside the enclosure. The gas is then ionized with cutting-edge technology to produce pure carbon that bonds with the seed to crystallize and form a diamond.' },
  { id: 4, question: 'How long do lab grown diamonds take to be made?', answer: 'Lab grown diamonds, created in state-of-the-art laboratories take 20-30 days to convert a tiny diamond seed into a rough lab grown diamond.' }
];

const expand = ref(null);

const openMenu = (id) => {
  expand.value = expand.value === id ? null : id;
};
</script>

<style scoped>
.mini_title {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 10px;
    cursor: pointer;
}
.mini_desc {
    font-size: 16px;
    font-weight: 500;
    padding: 0 0 10px 0;
}
 h4{
    font-size: 38px;
}
.according_title {
    font-size: 18px;
    padding: 1.3% 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.according_box {
    border-bottom: 1px solid #e2e2e2;
}
.according_box:first-child {
    border-top: 1px solid #e2e2e2;
}
.according_body {
    padding: 0 0 7px 0;
    /* border-top: 1px solid #e2e2e2; */
}
.according_body p {
    color: #6a6161;
    font-size: 16px;
    line-height: 1.5;
}
.down_arrow {
    height: 8px;
    width: 8px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(-135deg);
    transition: 0.5s;
    margin: 10px;
}
.up_arrow {
    height: 8px;
    width: 8px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(45deg);
    transition: 0.5s;
    margin: 10px;
}
a{
    color: var(--green);
    text-decoration: underline;
}
@media (max-width: 992px){
    h4{
        font-size: 32px;
    }
}
@media (max-width: 767px){
    .according_title {
        font-size: 16px;
        padding: 3% 0;
      
    }
}

</style>
